"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var EditableCell_1 = __importDefault(require("./EditableCell"));
var EditableRow_1 = __importDefault(require("./EditableRow"));
var EditableContext_1 = __importDefault(require("./EditableContext"));
var Button_1 = __importDefault(require("../Button"));
var Table_1 = __importDefault(require("../Table"));
var components = {
    body: {
        row: EditableRow_1.default,
        cell: EditableCell_1.default,
    },
};
var ConfirmPopup = function (_a) {
    var record = _a.record, handleSave = _a.handleSave, cancel = _a.cancel;
    var form = react_1.useContext(EditableContext_1.default);
    var save = function () {
        if (form) {
            form.validateFields(function (error, values) {
                if (error)
                    return;
                var newRecord = __assign({}, record, values);
                handleSave(newRecord);
            });
        }
    };
    return (react_1.default.createElement("span", null,
        react_1.default.createElement(Button_1.default, { icon: "commons-ok", onClick: save, style: { margin: 0 } }),
        react_1.default.createElement(Button_1.default, { icon: "commons-cancel", onClick: cancel })));
};
var EditableTable = function (_a) {
    var dataSource = _a.dataSource, columns = _a.columns, createItem = _a.createItem, updateItem = _a.updateItem, restProps = __rest(_a, ["dataSource", "columns", "createItem", "updateItem"]);
    var _b = react_1.useState(dataSource), dataState = _b[0], setDataState = _b[1];
    var _c = react_1.useState([]), editableColumns = _c[0], setEditableColumns = _c[1];
    var _d = react_1.useState(''), editingId = _d[0], setEditingId = _d[1];
    react_1.useEffect(function () { return setDataState(dataSource); }, [dataSource]);
    react_1.useEffect(function () {
        var isEditing = function (record) { return record.id === editingId; };
        var edit = function (id) { return setEditingId(id); };
        var cancel = function () { return setEditingId(''); };
        var save = function (record) { return __awaiter(_this, void 0, void 0, function () {
            var ok, newData, index, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(record.id === editingId)) return [3, 2];
                        return [4, updateItem(record)];
                    case 1:
                        ok = _a.sent();
                        if (ok) {
                            newData = dataState.slice();
                            index = newData.findIndex(function (i) { return i.id === record.id; });
                            newData[index] = record;
                            setDataState(newData);
                            setEditingId('');
                        }
                        return [3, 4];
                    case 2: return [4, createItem(record)];
                    case 3:
                        data = _a.sent();
                        if (data) {
                            setDataState(dataState.concat([data]));
                            setEditingId('');
                        }
                        _a.label = 4;
                    case 4: return [2];
                }
            });
        }); };
        var newColumns = columns.map(function (col) {
            if (col && col.editable) {
                var editable_1 = col.editable, colProps = __rest(col, ["editable"]);
                return __assign({}, colProps, { onCell: function (record) { return ({
                        record: record,
                        editable: editable_1,
                        dataIndex: col.dataIndex,
                        editing: isEditing(record),
                    }); } });
            }
            return col;
        });
        newColumns.push({
            title: 'Actions',
            dataIndex: 'actions',
            render: function (text, record) {
                var editing = isEditing(record);
                return editing ? (react_1.default.createElement(ConfirmPopup, { record: record, handleSave: save, cancel: cancel })) : (react_1.default.createElement(Button_1.default, { icon: "editing-pencil", disabled: editingId !== '', onClick: function () { return edit(record.id); } }));
            },
        });
        setEditableColumns(newColumns);
    }, [columns, editingId, dataState, createItem, updateItem]);
    return react_1.default.createElement(Table_1.default, __assign({ components: components, bordered: true, dataSource: dataState, columns: editableColumns }, restProps));
};
exports.default = EditableTable;
